import { render, staticRenderFns } from "./SheetBlockAssociatedBrochuresSelect.vue?vue&type=template&id=b95ed10c"
import script from "./SheetBlockAssociatedBrochuresSelect.vue?vue&type=script&lang=js"
export * from "./SheetBlockAssociatedBrochuresSelect.vue?vue&type=script&lang=js"
import style0 from "./SheetBlockAssociatedBrochuresSelect.vue?vue&type=style&index=0&id=b95ed10c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports